import request from '@utils/request'

export function fetchCertificationTypes() {
  return request({
    url: `/admin/kyc/certification/type`,
  })
}

export function fetchCertificationType(seq) {
  return request({
    url: `/admin/kyc/certification/type/${seq || 0}`,
    method: 'get',
  })
}

export function createCertificationType(data) {
  return request.post('/admin/kyc/certification/type', data)
}

export function updateCertificationType(data) {
  return request.put(`/admin/kyc/certification/type/${data.seq}`, data)
}

export function deleteCertificationType(seq) {
  return request.delete(`/admin/kyc/certification/type/${seq}`)
}

export function fetchCertificationList(params) {
  return request({
    url: '/admin/kyc/certification',
    method: 'get',
    params,
  })
}

export function fetchCertification(certification_seq) {
  return request.get(`/admin/kyc/certification/${certification_seq || 0}`)
}

export function rejectCertification(certification_seq) {
  return request({
    url: `/admin/kyc/certification/${certification_seq}`,
    method: 'patch',
    data: {
      type: 'SET_REJECTED',
    },
  })
}

export function approveCertification(certification_seq) {
  return request({
    url: `/admin/kyc/certification/${certification_seq}`,
    method: 'patch',
    data: {
      type: 'SET_APPROVED',
    },
  })
}

export function fetchRealnameList(params) {
  return request({
    url: '/admin/kyc/realname',
    method: 'get',
    params,
  })
}

export function fetchRealname(realname_seq) {
  return request.get(`/admin/kyc/realname/${realname_seq || 0}`)
}

export function fetchAssetWithdrawAddressCertificationList(params) {
  return request({
    url: '/admin/kyc/asset/withdraw/address/certification',
    method: 'get',
    params,
  })
}

export function fetchAssetWithdrawAddressCertification(certification_seq) {
  return request.get(
    `/admin/kyc/asset/withdraw/address/certification/${certification_seq || 0}`
  )
}
